import { translate } from 'src/app/project/features/translate/translate';
import { EUserRole } from '../../../share/share-utils/user-roles';

export function getDisabledUserManagementTooltipText(shareOption: EUserRole): string {
  switch (shareOption) {
    case EUserRole.ACCOUNT_ADMIN:
      return translate('cant_edit_account_admin_permission');
    case EUserRole.SITE_ADMIN:
      return translate('cant_edit_admin_permissions');
    case EUserRole.OWNER:
      return translate('cant_edit_owner_permissions');
    case EUserRole.NORMAL:
      return translate('cant_edit_normal_user_permissions');
    case EUserRole.LIMITED:
      return translate('cant_edit_limited_user_permissions');
    default:
      return '';
  }
}
